import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";

/**
 * Recursively checks if a block of a specific type exists in the block tree
 */
export const blockExists = (
  rootBlock: BaseBlock,
  blockType: string,
  conditionFunction = (block: BaseBlock): boolean => block.type === blockType,
): boolean => {
  // Check if the current block matches the type
  if (conditionFunction(rootBlock)) {
    return true;
  }

  // Check children recursively
  if (rootBlock.props.children?.value) {
    const children = rootBlock.props.children.value as BaseBlock[];
    return children.some(child =>
      blockExists(child, blockType, conditionFunction),
    );
  }

  return false;
};
